import { isNativeApp } from "@/lib/native/platform";
import appStoreBadge from "../assets/app-store-badge.svg";
import { APP_STORE_APP_ID } from "@shared/appStore";

// The FreshOrder iOS app's App Store listing (io.freshorder.app). Plain listing
// URL, no country segment and no campaign/tracking parameters.
export const APP_STORE_URL = `https://apps.apple.com/app/id${APP_STORE_APP_ID}`;

interface DeviceHints {
  native: boolean;
  userAgent: string;
  maxTouchPoints: number;
}

// iPhone and iPad web browsers only (Jon, 2026-10-21). Hidden inside the native
// shell (the buyer already has the app), on Android until the Play listing is
// live, and on desktop. iPadOS Safari reports a Mac user agent by default, so a
// "Macintosh" with a touchscreen is an iPad — a real Mac has no touch points.
export function shouldShowAppStoreBadge({ native, userAgent, maxTouchPoints }: DeviceHints): boolean {
  if (native) return false;
  if (/Android/i.test(userAgent)) return false;
  if (/iPhone|iPad|iPod/.test(userAgent)) return true;
  return /Macintosh/.test(userAgent) && maxTouchPoints > 1;
}

export function AppStoreBadgeLink() {
  return (
    <a
      href={APP_STORE_URL}
      target="_blank"
      rel="noopener noreferrer"
      className="inline-block"
      data-testid="link-app-store"
    >
      <img src={appStoreBadge} alt="Get the FreshOrder app on the App Store" className="h-10 w-auto" />
    </a>
  );
}

export function AppStoreBadge() {
  const show =
    typeof navigator !== "undefined" &&
    shouldShowAppStoreBadge({
      native: isNativeApp(),
      userAgent: navigator.userAgent,
      maxTouchPoints: navigator.maxTouchPoints ?? 0,
    });
  if (!show) return null;
  return (
    <div className="pt-2" data-testid="block-app-store">
      <AppStoreBadgeLink />
    </div>
  );
}
